import { render } from "./book-old-books.vue?vue&type=template&id=7b26ebec&scoped=true"
import script from "./book-old-books.js?vue&type=script&lang=js&external"
export * from "./book-old-books.js?vue&type=script&lang=js&external"

import "./book-old-books.css?vue&type=style&index=0&id=7b26ebec&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b26ebec"]])

export default __exports__